export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32')
];

export const server_loads = [0,3];

export const dictionary = {
		"/": [5],
		"/about": [21],
		"/(admin)/account": [~6,[2,3]],
		"/(admin)/account/api": [7,[2,3]],
		"/(admin)/account/blog": [~8,[2,3]],
		"/(admin)/account/blog/edit/[id]": [~9,[2,3]],
		"/(admin)/account/blog/new": [~10,[2,3]],
		"/(admin)/account/contact-submissions": [11,[2,3]],
		"/(admin)/account/create_profile": [12,[2,3]],
		"/(admin)/account/select_plan": [13,[2,3]],
		"/(admin)/account/settings": [14,[2,3]],
		"/(admin)/account/sign_out": [15,[2,3]],
		"/(admin)/account/subscribe/[slug]": [~16,[2,3]],
		"/blog": [~22,[4]],
		"/blog/[slug]": [~23,[4]],
		"/contact": [24],
		"/cookie-policy": [25],
		"/(auth)/forgot-password": [17],
		"/(auth)/login": [18],
		"/privacy": [26],
		"/(auth)/register": [19],
		"/(auth)/reset-password": [20],
		"/services": [27],
		"/services/development": [28],
		"/services/strategy": [29],
		"/services/support": [30],
		"/signup": [31],
		"/terms": [32]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';